export const SUPPORT_EMAIL = window.NINA.email
export const AJAX_URL = window.NINA.ajax

export const MENU_OPEN = 'menu-open'
export const MODAL_OPEN = 'modal-open'
export const SEARCH_OPEN = 'search-open'

export const ACTIVE_CLASS = 'is-active'
export const LOADING_CLASS = 'is-loading'

export const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)',
).matches

export const saveData =
  'connection' in navigator && navigator.connection.saveData === true
